<!--  -->
<template>
  <div class="add_box">
    <div class="sarch_box">
      <div class="search_box">
        <el-input
          v-model="objr.keyword"
          placeholder="请输入域名"
        />
        域名类型：
        <el-select
          v-model="objr.domain_type"
          placeholder="请选择"
        >
          <el-option
            v-for="item in domain_options"
            :key="item.type"
            :label="item.name"
            :value="item.type"
          />
        </el-select>
        域名状态：
        <el-select
          v-model="objr.status"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="sraw"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="reset"
        >重置</el-button>
      </div>
      <el-button
        type="success"
        icon="el-icon-circle-plus"
        @click="addbit"
      >新增域名</el-button>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="id"
        align="center"
        label="id"
      />
      <el-table-column
        align="center"
        prop="domain"
        label="域名"
      />
      <el-table-column
        prop="domain_type_text"
        align="center"
        label="域名类型"
      />
      <el-table-column
        prop="status_text"
        align="center"
        label="状态"
      >
        <template slot-scope="scope">
          <i
            v-if="scope.row.status == 1"
            class="el-icon-success defaultr"
          />
          <i
            v-if="scope.row.status == 2"
            class="el-icon-remove-outline stopew"
          />
          <i
            v-if="scope.row.status == 3"
            class="el-icon-close stopew"
          />
          {{ scope.row.status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="是否停用"
        width="190"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <el-button type="primary" size="mini">解绑</el-button> -->
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="rgb(191,191,191)"
            active-text="正常"
            inactive-text="停用"
            :active-value="1"
            :inactive-value="2"
            @change="stopr($event,scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at_text"
        label="创建时间"
      />
      <el-table-column
        align="center"
        prop="admin_name"
        label="管理员名"
      />
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
        width="200"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleter(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
    <el-dialog
      title="域名"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
    >
      <bitdialog
        ref="addbiz"
        @updatawe="updatawe"
      />
    </el-dialog>
  </div>
</template>

<script>
import bitdialog from './components/bitdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { domainname, domainconfiguredel, domainConfigureStop, authorizationtypelist } from '@/api/sourceMaterial.js'
export default {
  name: 'Domainname',
  components: {
    bitdialog,
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      newtotalr: null,
      adtype: null,
      objr: {
        page: 1,
        page_size: 10,
        keyword: null,
        status: null,
        domain_type: 0
      },
      options: [
        {
          value: null,
          label: '全部'
        },
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '停用'
        },
        {
          value: 3,
          label: '被封'
        }
      ],
      domain_options: [
        { type: 0, name: '全部' }
      ],
      domain_list: [],
      tableData: []
    }
  },
  created() {
    this.menuList()
    this.domainList()
  },
  mounted() {},
  methods: {
    async domainList() {
      authorizationtypelist().then(res => {
        this.domain_list = res.data.list
        this.domain_options = [...this.domain_options, ...res.data.list]
        console.log(this.domain_options)
      })
    },
    async menuList() {
      // 获取列表
      const data = await domainname(this.objr)
      console.log('data', data)
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    addbit() {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.addbiz.send(1, { 'domain_list': this.domain_list })
      }, 100)
    },
    edit(item) {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.addbiz.send(2, { item, 'domain_list': this.domain_list })
      }, 100)
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.page_size = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    sraw() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.menuList()
    },
    reset() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.objr.keyword = null
      this.objr.status = null
      this.menuList()
    },
    deleter(id) {
      this.$confirm('此操作确定删除？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          domainconfiguredel({
            id: id
          }).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.menuList()
          })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
    },
    stopr(val, item) {
      console.log('val', val)
      this.$confirm(`此操作确定${val === 1 ? '启用' : '停用'}吗？ 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          domainConfigureStop({
            id: item.id,
            status: val
          }).then(res => {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.menuList()
          })
        })
        .catch(() => {
          this.menuList()
          this.$message({
            type: 'info',
            message: '已取消停用'
          })
        })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.sarch_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
